import type { SmeCardView } from "../../../api/types";
import { ReasonDialog } from "../shared/ReasonDialog";
import { answerChoices, type AnswerKind } from "./decide";
import type { AnswerTarget } from "./useCardAnswers";

const TEXT: Record<AnswerKind, { title: string; label: string; hint: string; confirm: string }> = {
  send_back: {
    title: "Send back with a comment",
    label: "Your comment",
    hint: "The engineer reads this next to the card. Name the line or value if it is about only one.",
    confirm: "Send back",
  },
  reject: {
    title: "Reject with a reason",
    label: "Your reason",
    hint: "Reject says this should not be an element at all. For something that can be fixed, use Send back instead.",
    confirm: "Reject",
  },
  note: {
    title: "Add a note",
    label: "Your note",
    hint: "A note changes no state. The card stays waiting for you, and the engineer answers with a note.",
    confirm: "Add the note",
  },
};

interface AnswerDialogProps {
  card: SmeCardView;
  target: AnswerTarget | null;
  busy: boolean;
  error: string | null;
  onConfirm: (text: string, lineId: string) => void;
  onCancel: () => void;
}

/** The form for Send back (a comment is required), Reject (a reason is required) and Note. */
export function AnswerDialog({ card, target, busy, error, onConfirm, onCancel }: AnswerDialogProps) {
  if (!target) return null;
  const words = TEXT[target.kind];
  return (
    <ReasonDialog
      key={`${target.kind}:${target.lineId}`}
      title={words.title}
      label={words.label}
      hint={words.hint}
      confirmLabel={words.confirm}
      about={answerChoices(card, target.kind)}
      aboutLabel={target.kind === "note" ? "What the note is about" : "What it is about"}
      initialAbout={target.lineId}
      busy={busy}
      error={error}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
